import React, { useState } from "react";
import "./CustomerOutcomeShowcase.css";
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const TAB_DATA = [
  {
    key: "growth",
    label: "Growth (<200 employees)",
    brand: "TourRadar",
    title: "Why TourRadar chose our platform for easy HR setup",
    video: "/images/vido3.mp4",
    stats: [
      { value: "40+", label: "hours saved" },
      { value: "170+", label: "employees" },
      { value: "160+", label: "countries" }
    ]
  },
  {
    key: "scale",
    label: "Scale (200–1000 employees)",
    brand: "PeopleStack",
    title: "Scaling HR operations without overhead",
    video: "/images/vid2.mp4",
    stats: [
      { value: "65+", label: "hours saved" },
      { value: "650+", label: "employees" },
      { value: "25+", label: "locations" }
    ]
  },
  {
    key: "enterprise",
    label: "Enterprise (1000+ employees)",
    brand: "GlobalCorp",
    title: "Enterprise HR with compliance control",
    video: "/images/vido4.mp4",
    stats: [
      { value: "120+", label: "hours saved" },
      { value: "2500+", label: "employees" },
      { value: "60+", label: "countries" }
    ]
  }
];

const CustomerOutcomeShowcase = () => {
  const [activeTab, setActiveTab] = useState("growth");
  const activeData = TAB_DATA.find(tab => tab.key === activeTab);
  const navigate = useNavigate();
  const handleRecruit = () => navigate('/access-recruit');

  if (!activeData) return null;

  return (
    <section className="cos-wrapper">
      {/* Header */}
      <div className="cos-header">
        <h2 className="cos-title">
          Real <span className="cos-highlight">outcomes</span>. Real{" "}
          <span className="cos-highlight">fast</span>.
        </h2>
        <p>See how companies succeed using our platform.</p>
      </div>

      {/* Tabs */}
      <div className="cos-tabs">
        {TAB_DATA.map(tab => (
          <button
            key={tab.key}
            type="button"
            className={`cos-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Card */}
      <div className="cos-card">
        {/* Video */}
        <div className="cos-video">
          <video
            key={activeTab}
            src={activeData.video}
            controls
            autoPlay
            muted
            playsInline
            preload="metadata"
            className="cos-video-player"
          />
        </div>

        {/* Content */}
        <div className="cos-content">
          <span className="cos-brand">{activeData.brand}</span>
          <h3>{activeData.title}</h3>

          <div className="cos-stats">
            {activeData.stats.map((stat, index) => (
              <div key={index}>
                <h4>{stat.value}</h4>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>

          <a href="/aboutpage" className="cos-link">
            Read their story <FaArrowRight className="cos-arrow-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CustomerOutcomeShowcase;